import { render } from "./CreateCreative.vue?vue&type=template&id=8e5731c6&scoped=true"
import script from "./CreateCreative.vue?vue&type=script&lang=js"
export * from "./CreateCreative.vue?vue&type=script&lang=js"

import "./CreateCreative.vue?vue&type=style&index=0&id=8e5731c6&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e5731c6"]])

export default __exports__